<template>
    <div class="page-margin-20-40">
        <v-container>
            <v-row dense>
                <v-col cols="12" md="3">
                    <v-card color="indigo" flat elevation="1" class="grad rounded-lg">
                        <v-card-title class="d-flex justify-space-between text-white pa-2">
                            <span>Revenue</span>
                            <span>+16% <v-icon>mdi-arrow-up-thin</v-icon></span>
                        </v-card-title>
                        <v-card-text>
                            <div class="d-flex justify-space-between text-center text-white">
                                <div>
                                    <div class="text-h6">£{{paidRev.toFixed(2)}}</div>
                                    <div class="font-weight-bold">Paid</div>
                                </div>
                                <div>
                                    <div class="text-h6">£{{pendingRev.toFixed(2)}}</div>
                                    <div class="font-weight-bold">Pending</div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="3">
                    <v-card color="red" elevation="1" class="grad rounded-lg">
                        <v-card-title class="d-flex justify-space-between text-white pa-2">
                            <span>Orders</span>
                            <span>+16% <v-icon>mdi-arrow-up-thin</v-icon></span>
                        </v-card-title>
                        <v-card-text>
                            <div class="d-flex justify-space-between text-center text-white">
                                <div>
                                    <div class="text-h6">{{ordersCount}}</div>
                                    <div class="font-weight-bold">Paid</div>
                                </div>
                                <div>
                                    <div class="text-h6">{{pendingOrd}}</div>
                                    <div class="font-weight-bold">Pending</div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="3">
                    <v-card color="green" elevation="1" class="grad rounded-lg">
                        <v-card-title class="d-flex justify-space-between text-white pa-2">
                            <span>Products</span>
                            <span>+16% <v-icon>mdi-arrow-up-thin</v-icon></span>
                        </v-card-title>
                        <v-card-text>
                            <div class="d-flex justify-space-between text-center text-white">
                                <div>
                                    <div class="text-h6">{{productsCount}}</div>
                                    <div class="font-weight-bold">Products</div>
                                </div>
                                <div>
                                    <div class="text-h6">{{variantsCount}}</div>
                                    <div class="font-weight-bold">Variants</div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="3">
                    <v-card color="info" elevation="1" class="grad rounded-lg">
                        <v-card-title class="d-flex justify-space-between text-white pa-2">
                            <span>Users</span>
                            <span>+16% <v-icon>mdi-arrow-up-thin</v-icon></span>
                        </v-card-title>
                        <v-card-text>
                            <div class="d-flex justify-space-between text-white text-center">
                                <div>
                                    <div class="text-h6">{{0}}</div>
                                    <div class="font-weight-bold">Paid</div>
                                </div>
                                <div>
                                    <div class="text-h6">{{custNew}}</div>
                                    <div class="font-weight-bold">Pending</div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card class="border-sm">
                        <v-card-title class="d-flex justify-space-between grad bg-indigo text-white pa-2">
                            <span>Revenue</span>
                            <span><v-icon>mdi-dots-horizontal</v-icon></span>
                        </v-card-title>
                        <apexchart type="area" :options="roptions" :series="rseries"></apexchart>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card class="border-sm">
                        <v-card-title class="d-flex justify-space-between grad text-white bg-info pa-2">
                            <span>Visitors</span>
                            <span><v-icon>mdi-dots-horizontal</v-icon></span>
                        </v-card-title>
                        <apexchart type="bar" :options="visoptions" :series="visseries"></apexchart>
                    </v-card>
                </v-col>
                <v-col cols="12" md="8">
                    <v-card>
                        <v-card-title class="d-flex justify-space-between grad bg-red text-white pa-2">
                            <span>Recent Orders</span>
                            <span><v-icon>mdi-dots-horizontal</v-icon></span>
                        </v-card-title>
                        <v-data-table :items="rorders" :headers="rordersHeaders" hide-default-footer>
                            <template v-slot:item.items_count="{item}">
                                <div class="font-weight-medium">{{item.items_count}} item<span v-if="item.items_count > 1">s</span></div>
                            </template>
                            <template v-slot:item.total_amount="{item}">
                                £ {{item.total_amount}}
                            </template>
                            <template v-slot:item.placed_at="{item}">
                                <div class="font-weight-medium">{{dayjs(item.placed_at).format('D MMM [at] h:mm a')}}</div>
                            </template>
                            <template v-slot:item.fulfillment_status="{item}">
                                <v-chip v-if="item.fulfillment_status === 'unfulfilled'" color="red" small class="text-capitalize font-weight-medium">{{item.fulfillment_status}}</v-chip>
                                <v-chip v-else color="green" small class="text-capitalize font-weight-medium">{{item.fulfillment_status}}</v-chip>
                            </template>
                            <template v-slot:item.actions="{item}">
                                <v-btn icon="mdi-eye" density="compact" variant="text" color="info"></v-btn>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4">
                    <v-card class="border-sm">
                        <v-card-title class="d-flex justify-space-between grad bg-green pa-2">
                            <span>Top Sold</span>
                            <span><v-icon>mdi-dots-horizontal</v-icon></span>
                        </v-card-title>
                        <v-data-table :items="tpros" :headers="tprosHeaders" hide-default-footer>
                            <template v-slot:item.mproduct_image="{item}">
                                <v-img :src="cdn+item.mproduct_image" width="40" height="39" class="rounded-lg my-1"></v-img>
                            </template>
                            <template v-slot:item.mproduct_title="{item}">
                                <div>{{item.mproduct_title}}</div>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
            <v-row dense align="stretch">
                <v-col cols="12" md="3">
                    <v-card class="border-sm h-100">
                        <v-card-title class="d-flex justify-space-between grad text-white bg-indigo pa-2">
                            <span>Traffic Source</span>
                            <span><v-icon>mdi-dots-horizontal</v-icon></span>
                        </v-card-title>
                        <apexchart type="donut" :options="toptions" :series="tseries"></apexchart>
                    </v-card>
                </v-col>
                <v-col cols="12" md="3">
                    <v-card class="border-sm h-100">
                        <v-card-title class="d-flex justify-space-between grad text-white bg-red pa-2">
                            <span>Traffic By Device</span>
                            <span><v-icon>mdi-dots-horizontal</v-icon></span>
                        </v-card-title>
                        <apexchart type="donut" :options="bdoptions" :series="bdseries"></apexchart>
                    </v-card>
                </v-col>
                <v-col cols="12" md="3">
                    <v-card class="border-sm h-100">
                        <v-card-title class="d-flex justify-space-between grad bg-green text-white pa-2">
                            <span>Sales by Country</span>
                            <span><v-icon>mdi-dots-horizontal</v-icon></span>
                        </v-card-title>
                        <apexchart type="pie" :options="coptions" :series="cseries"></apexchart>
                    </v-card>
                </v-col>
                <v-col cols="12" md="3">
                    <v-card class="border-sm h-100">
                        <v-card-title class="d-flex justify-space-between text-white grad bg-info pa-2">
                            <span>Sales by Channels</span>
                            <span><v-icon>mdi-dots-horizontal</v-icon></span>
                        </v-card-title>
                        <apexchart type="radialBar" :options="rboptions" :series="rbseries"></apexchart>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import axios from 'axios'
import dayjs from "dayjs";
export default {
    name: "AdminDashboard",
    data() {
        return {
            cdn: 'https://cdn.truewebpro.com/',
            paidRev:0,
            pendingRev:0,
            shippedOrd:0,
            pendingOrd:0,
            ordersCount:0,
            productsCount:0,
            variantsCount:0,
            shopUsers:0,
            custReturned:0,
            custNew:0,
            tpros:[],
            tprosHeaders:[
                {text:'Image',value:'mproduct_image',width:90},
                {text:'Product',value:'mproduct_title'},
            ],
            rorders:[],
            rordersHeaders:[
                {text:'#ID',value:'order_id'},
                {text:'Customer',value:'name'},
                {text:'Quantity',value:'items_count'},
                {text:'Total',value:'total_amount'},
                {text:'Date',value:'placed_at'},
                {text:'Status',value:'fulfillment_status'},
            ],
            users:'',
            orders:'',
            revenue:'',
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            dataset1: [90, 85, 100, 95, 160, 120, 60, 90, 150, 170, 130, 100],
            dataset2: [90, 90, 90, 85, 80, 70, 40, 80, 60, 130, 90, 60],
            maxValue: 180,
            summaryCards: [
                { label: "Total Users", count: 0, icon: "mdi-account" },
                { label: "Total Orders", count: 0, icon: "mdi-cart" },
                { label: "Revenue", count: 0, icon: "mdi-currency-gbp" }
            ],
            radius: 10,
            padding: 8,
            gradient: 3,
            autoLineWidth: false,
            gradients: [
                ['#222'],
                ['#42b3f4'],
                ['red', 'orange', 'yellow'],
                ['purple', 'violet'],
                ['#00c6ff', '#F0F', '#FF0'],
                ['#f72047', '#ffd200', '#1feaea'],
            ],
            roptions: {
                chart: {
                    id: 'revenue',
                    zoom:{enabled:false},
                },
                colors: ['#8e2de2', '#4a00e0'],
                dataLabels: {
                    enabled: false
                },
                xaxis: {
                    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul','Aug','Sep','Oct','Nov','Dec'],
                }
            },
            rseries: [{
                name: 'Revenue 2024',
                data: [38, 40, 45, 50, 49, 60, 62,65,66,64,44,44]
            },
                {
                    name: 'Revenue 2025',
                    data: [40, 38, 45,66,64,44,44,50, 49, 60, 62,65]
                }],
            bdoptions: {
                chart:{
                    id:"Source",
                    type:'donut'
                },
                legend:{position:'bottom'},
                labels: ["Desktop", "Tablet", "Mobile"],
            },
            bdseries: [30, 45, 35],
            toptions: {
                chart:{
                    id:"Source",
                    type:'donut'
                },
                legend:{position:'bottom'},
                labels: ["Social", "Direct", "Search"],
            },
            tseries: [20, 65, 15],
            visoptions: {
                chart: {
                    id: 'visitors1'
                },
                colors: ['orange', 'chocolate'],
                xaxis: {
                    categories: ['Mo', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                }
            },
            visseries: [{
                name: 'Last Week',
                data: [25, 32, 38, 42, 41, 49, 54]
            },{
                name: 'This Week',
                data: [30, 40, 45, 50, 49, 60, 70]
            }],
            options: {
                chart: {
                    id: 'vuechart-example'
                },
                xaxis: {
                    categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
                }
            },
            series: [{
                name: 'series-1',
                data: [30, 40, 45, 50, 49, 60, 70, 91]
            }],
            coptions: {
                chart:{
                    id:"Source",
                    type:'donut'
                },
                legend:{position:'bottom'},
                labels: ["UK", "USA", "Canada",'Europe'],
            },
            cseries: [30,45,35,20],
            rboptions: {
                chart:{
                    id:"Channels",
                    type:'radialBar'
                },
                plotOptions: {
                    radialBar: {
                        dataLabels: {
                            name: {fontSize: '22px',},
                            value: {fontSize: '16px',},
                            total: {show: true, label: 'Total',
                                formatter: function (w) {return 249}
                            }
                        }
                    }
                },
                labels: ["Email", "Facebook", "Instagram",'Twitter'],
            },
            rbseries: [44, 55, 67, 83],
        }
    },
    mounted() {
        this.fetchCounts()
        this.getStyle()
    },
    methods: {
        dayjs,
        getStyle(value, index) {
            const left = `${index * 8.5}%`
            const bottom = `${(value / this.maxValue) * 100}%`
            return {
                left,
                bottom
            }
        },
        async fetchCounts () {
            try {
                const { data } = await axios.get('/admin/dashboard/vlist')
                this.summaryCards[0].count = data.total_users
                this.summaryCards[1].count = data.total_orders
                this.summaryCards[2].count = data.revenue
                this.users = data.total_users;
                this.orders = data.total_orders;
                this.revenue = data.revenue;
                this.rorders = data.orders;
                this.pendingRev = data.pendingRev;
                this.paidRev = data.paidRev;
                this.shippedOrd = data.shippedOrd;
                this.pendingOrd = data.pendingOrd;
                this.ordersCount = data.ordersCount;
                this.productsCount = data.productsCount;
                this.variantsCount = data.variantsCount;
                this.tpros = data.tpros;
                this.custNew = data.usersNew;
            } catch (e) {
                console.error('Failed to load counts', e)
            }
        }
    }
}
</script>

<style scoped>
.static-graph {
    position: relative;
    height: 100px;
    width: 100%;
    border-left: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
}
.graph-line {
    position: absolute;
    height: 100%;
    width: 100%;
}
.point {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transform: translate(-50%, 50%);
}
.dataset1 .point {
    background-color: #e67e22;
}
.dataset2 .point {
    background-color: #27ae60;
}
.grad.indigo,.grad.bg-indigo {
    background: linear-gradient(to right, #8e2de2, #4a00e0) !important;
}
.grad.red,.grad.bg-red {
    background: linear-gradient( 45deg , #ee0979, #ff6a00) !important;
}
.grad.green,.grad.bg-green {
    background: linear-gradient( 45deg , #00b09b, #96c93d) !important;
}
.grad.info,.grad.bg-info {
    background: linear-gradient(to right,orange, chocolate) !important;
}
</style>
